/* @flow */
export default function getLocaleStringLocales(number) {
  try {
    return number.toLocaleString();
  } catch (e) {
    return '';
  }
}
